import React from "react";
import Hero from "./hero";
import About1 from "./about";
import Service from "./service";
import Process from "./process";
import Portfilio from "./portfilio";
import Contact from "./contact";
import Seo, { SITE_URL } from "./Seo";

const homeSchema = [
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "@id": `${SITE_URL}/#website`,
    url: SITE_URL,
    name: "Aashish Timsina",
    inLanguage: "en",
  },
  {
    "@context": "https://schema.org",
    "@type": "Person",
    "@id": `${SITE_URL}/#person`,
    name: "Aashish Timsina",
    url: SITE_URL,
    image: `${SITE_URL}/og-image.jpg`,
    jobTitle: "Backend Developer & Web Scraper",
    email: "mailto:timsinaaashish6@gmail.com",
    address: {
      "@type": "PostalAddress",
      addressLocality: "Pokhara",
      addressRegion: "Gandaki",
      addressCountry: "NP",
    },
    knowsAbout: [
      "Web scraping",
      "Python",
      "Scrapy",
      "PostgreSQL",
      "Node.js",
      "Express.js",
      "MongoDB",
      "MySQL",
      "REST API development",
      "SERP scraping",
      "Puppeteer",
      "Playwright",
    ],
    sameAs: [
      "https://github.com/aashish0241",
      "https://www.linkedin.com/in/aashish-timsina-663ab02a8",
      "https://www.upwork.com/freelancers/~01d263ff08e4a7d498",
    ],
  },
  {
    "@context": "https://schema.org",
    "@type": "ProfessionalService",
    "@id": `${SITE_URL}/#service`,
    name: "Aashish Timsina - Web Scraping & Backend Development",
    url: SITE_URL,
    image: `${SITE_URL}/og-image.jpg`,
    telephone: "+9779861524169",
    email: "timsinaaashish6@gmail.com",
    address: {
      "@type": "PostalAddress",
      addressLocality: "Pokhara",
      addressRegion: "Gandaki",
      addressCountry: "NP",
    },
    geo: {
      "@type": "GeoCoordinates",
      latitude: 28.2096,
      longitude: 83.9856,
    },
    areaServed: ["Nepal", "Worldwide"],
    serviceType: [
      "Web scraping",
      "SERP scraping",
      "Data extraction",
      "Backend development",
      "API development",
    ],
    founder: { "@id": `${SITE_URL}/#person` },
  },
];

const LandingPage = () => {
  return (
    <div className="bg-dark-900 text-light-100">
      <Seo
        title="Aashish Timsina | Backend Developer in Nepal | Web Scraper"
        description="Backend developer in Nepal delivering scalable APIs, automation, and data-focused web scraper solutions for startups and businesses."
        path="/"
        jsonLd={homeSchema}
      />
      <Hero />
      <About1 />
      <Service />
      <Process />
      <Portfilio />
      <Contact />
    </div>
  );
};

export default LandingPage;
